import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { GUIDES } from "@/content/advice";
import { Seo } from "@/components/Seo";
import { breadcrumbJsonLd } from "@/components/Breadcrumb";
import { PageHero } from "@/components/PageHero";
import { Reveal } from "@/components/Reveal";
import { CtaBand } from "@/components/home/CtaBand";

const BREADCRUMB = [
  { label: "Home", to: "/" },
  { label: "Advice", to: "/advice" },
];

export default function AdviceIndex() {
  return (
    <div data-testid="advice-index-page">
      <Seo
        title="Advice & Guides | DMS Home Improvements"
        description="Plain-English guides on extension costs, loft conversion timelines, planning permission, plastering and choosing a builder, from DMS Home Improvements in Molesey and Kingston."
        jsonLd={breadcrumbJsonLd(BREADCRUMB)}
      />
      <PageHero
        eyebrow="Advice"
        h1="Advice & Guides"
        intro="Straight, jargon-free guides to help you plan building work with confidence. No sales pitch and no scary numbers — just what we would tell you on the doorstep."
        breadcrumb={BREADCRUMB}
      />

      <section data-testid="advice-grid-section" className="bg-white pb-16 md:pb-24">
        <div className="container-site">
          <ul className="grid gap-6 md:grid-cols-2 xl:gap-8">
            {GUIDES.map((g, i) => (
              <Reveal as="li" key={g.id} delay={i * 60}>
                <Link
                  to={g.path}
                  data-testid={`advice-card-${g.id}`}
                  className="card group flex h-full flex-col p-6 transition-[border-color] duration-200 hover:border-brand md:p-8"
                >
                  <p className="eyebrow">Guide</p>
                  <h2 className="mt-3 text-2xl">{g.h1}</h2>
                  <p className="mt-3 text-base text-body">{g.cardBlurb}</p>
                  <span className="mt-6 inline-flex items-center gap-2 text-[15px] font-semibold text-brand">
                    Read the {g.name.toLowerCase()} guide
                    <ArrowRight size={18} aria-hidden="true" className="transition-transform duration-200 ease-out group-hover:translate-x-1" />
                  </span>
                </Link>
              </Reveal>
            ))}
          </ul>
        </div>
      </section>

      <CtaBand />
    </div>
  );
}
